import { Component, OnInit, Output, EventEmitter, ViewChild, TemplateRef, OnChanges, SimpleChanges, Input } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
    selector: 'app-auto-enrol-insurance-pop-up',
    templateUrl: './auto-enrol-insurance-pop-up.component.html',
    styleUrls: ['./auto-enrol-insurance-pop-up.component.scss'],
    standalone: false
})
export class AutoEnrolInsurancePopUpComponent implements OnInit, OnChanges {
  @ViewChild('showpopup', { static: true }) showpopup: TemplateRef<any>;
  @ViewChild('showpopupforpartialPayment', { static: true }) showpopupforpartialPayment: TemplateRef<any>;
  @ViewChild('showpopupforzeroPayment', { static: true }) showpopupforzeroPayment: TemplateRef<any>;
  @Output() PayTerminatedpropertyProtection = new EventEmitter<void>();
  @Output() CancelAutoEnrollPP = new EventEmitter<void>();
  @Output() CancelAutoEnrollPPWithNoDue = new EventEmitter<void>();
  @Output() ContinueWithAutoEnrollPP = new EventEmitter<void>();
  @Output() OnClosePartialPaymentPopUp = new EventEmitter<void>();
  @Input() isShowAutoEnrolledPopuUp: boolean = false;
  @Input() show_PartialPaymentPopup: boolean = false;
  @Input() show_zeroPaymentPopup: boolean = false;
  @Input() AutoEnrolExpiredInsWithNoCharge: boolean = false;
  @Input() AutoEnrollPropertyProtection: boolean = false;
  public show_popupforPArtialPayment: BsModalRef;
  public show_popup: BsModalRef;
  show_popupforzeroPayment: BsModalRef;
  constructor(private generalService: GeneralService, private modalService: BsModalService,) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isShowAutoEnrolledPopuUp'] && changes['isShowAutoEnrolledPopuUp'].currentValue === true) {
      this.openPopup();
    }
    if (changes['show_PartialPaymentPopup'] && changes['show_PartialPaymentPopup'].currentValue === true) {
      this.OpenPartialPaymentPopUp();
    }
    if (changes['show_zeroPaymentPopup'] && changes['show_zeroPaymentPopup'].currentValue === true) {
      this.OpenZeroPaymentPopup();
    }
  }

  autoEnrollInsurance(): void {
    this.PayTerminatedpropertyProtection.emit();
    this.show_popup.hide();
  }

  RemoveAEnrolledPP(): void {
    this.CancelAutoEnrollPP.emit();
    this.show_popupforPArtialPayment?.hide();
    this.show_popupforzeroPayment?.hide();
  }
  RemoveAutoEnrolledPPWithNoDue() {
    this.CancelAutoEnrollPPWithNoDue.emit();
    this.show_popupforzeroPayment?.hide();
  }
  ContinueWithEnrolledPP(): void {
    this.ContinueWithAutoEnrollPP.emit();
    this.show_popupforPArtialPayment?.hide();
    this.show_popupforzeroPayment?.hide();
  }

  closePartialPaymentPopUp(): void {
    this.OnClosePartialPaymentPopUp.emit();
    this.show_popupforPArtialPayment?.hide();
    this.show_popupforzeroPayment?.hide();
  }

  openPopup() {
    this.show_popup = this.modalService.show(this.showpopup, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
  }
  OpenPartialPaymentPopUp() {
    this.show_popupforPArtialPayment = this.modalService.show(this.showpopupforpartialPayment, { class: 'modal-dialog modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
  }
  OpenZeroPaymentPopup() {
    this.show_popupforzeroPayment = this.modalService.show(this.showpopupforzeroPayment, { class: 'modal-dialog modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
  }
}
